module.exports = __webpack_public_path__ + "img/0-02-0a-bcf07d74e1336e68414bcdbeec377c64d7b284d22aa56d0e017d443d2af74a40_9b1236a7.d6c20674.jpg";